import { useThemePreference, type ThemePreference } from "../../shell/useTheme";
import { Panel } from "../../ui/Panel";
import { Segmented } from "../../ui/Segmented";

/**
 * Inställningar › Utseende, the client's half of design.md section 3's three choices.
 *
 * Decided 2026-09-24 with the sketch: the theme lives here and the header toggle goes away. The same
 * hook and the same stored key as Petrovic's own Utseende in `AdminSettingsRoute.tsx`, so a choice made
 * on one side holds on the other. "System" is the absence of a stored choice.
 */
const THEME_OPTIONS = [
  { value: "light", label: "Ljust" },
  { value: "dark", label: "Mörkt" },
  { value: "system", label: "System" }
] as const;

export function AppearancePanel() {
  const { preference, setPreference } = useThemePreference();

  return (
    <Panel title="Utseende" titleId="appearance-title">
      <Segmented<ThemePreference>
        label="Tema"
        value={preference}
        options={THEME_OPTIONS}
        onChange={setPreference}
        testId="client-theme"
      />
    </Panel>
  );
}
